import { BaseMarkerFactory } from '../../../../../../_shared/interfaces/maps/base-marker-factory';

const INCIDENT_MARKER_COLOR = '#ff7f00';

export class IncidentMarkerFactory extends BaseMarkerFactory {
  protected override createMarkerDiv(): HTMLDivElement {
    const markerDiv = document.createElement('div');

    // Phosphor's navigation arrow points north-west, so a 45deg turn points it up as in the design
    markerDiv.innerHTML = `
      <div style="width:24px;height:24px;border-radius:50%;background:${INCIDENT_MARKER_COLOR};display:flex;align-items:center;justify-content:center;">
        <i class="ph-fill ph-navigation-arrow" style="color:#ffffff;font-size:12px;transform:rotate(45deg);"></i>
      </div>`;

    return markerDiv;
  }

  protected override createTitle(): string {
    return '';
  }
}